// extracted by css-extract-rspack-plugin
export default {"order_icon":"dqIY3","orderIcon":"dqIY3","subtitle":"fU9Pk"};